import api from './axios';

export const adminSponsorPricingApi = {
  list: (params = {}) => api.get('/admin/sponsor-pricing-tiers', { params }).then((r) => r.data),
  getById: (id) => api.get(`/admin/sponsor-pricing-tiers/${id}`).then((r) => r.data),
  create: (data) => api.post('/admin/sponsor-pricing-tiers', data).then((r) => r.data),
  update: (id, data) => api.patch(`/admin/sponsor-pricing-tiers/${id}`, data).then((r) => r.data),
  deactivate: (id) => api.delete(`/admin/sponsor-pricing-tiers/${id}`).then((r) => r.data),
  importXlsx: (file) => {
    const formData = new FormData();
    formData.append('file', file);
    return api.post('/admin/sponsor-pricing-tiers/import', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }).then((r) => r.data);
  },
};
